// Libraries
import { Box, Flex, Text, UseRadioProps, useRadio } from '@chakra-ui/react';

/**
 * A custom radio component designed to display ratings.
 *
 * @component
 * @param {UseRadioProps} props - The properties passed to the radio component.
 *
 * @returns {ReactElement} The RatingRadio component.
 */
export const RatingRadio = (props: UseRadioProps) => {
  const { getInputProps, getRadioProps } = useRadio(props);
  const inputProps = getInputProps();
  const checkboxProps = getRadioProps();

  return (
    <Box as='label'>
      <input {...inputProps} />
      <Flex
        {...checkboxProps}
        gap={1}
        h={7}
        w={11}
        align='center'
        justify='center'
        border='greyCheck'
        borderRadius='100px'
        cursor='pointer'
        _checked={{
          color: 'white',
          boxShadow: 'dropdown',
          border: 'selectedStrong',
        }}
        _focusVisible={{
          boxShadow: 'outline',
        }}
        _disabled={{
          cursor: 'not-allowed',
          borderColor: 'gray.200',
          background: 'gray.200',
          color: 'gray.500',
          opacity: 0.4,
          boxShadow: 'none',
        }}
      >
        <Box boxSize={3.5} borderRadius='base' bg={`ratings.${props.value}.dark`} />
        <Text fontSize='m' userSelect='none'>
          {props.value}
        </Text>
      </Flex>
    </Box>
  );
};
